export default {
	admin: 'Admin',
	adminLogin: 'Login',
	home: 'Home',
	loading: 'Loading...',
	noPower: 'No access permission',
	notFound: 'Page not found',
	noTitle: 'No title',
	user: 'Member Center',
	userLogin: 'Menber Login',
}
